import { AuditClassName, TypeEnum } from './models/audit';

export const auditClassNameLabels: Record<AuditClassName, string> = {
  Base: 'Base',
  BeneD: 'Disegno',
  BeneF: 'Foto',
  BeneMI: 'Matrice Incisa',
  BeneOA: 'Oggetto Artistico',
  BeneS: 'Stampa',
  Collezione: 'Collezione',
  DocumentoArc: 'Doc. Archivistico',
  DocumentoBib: 'Doc. Bibliografico',
  File: 'File',
  OggettoCollezione: 'Oggetto Collezione',
  Persona: 'Persona',
  Role: 'Ruolo',
  Session: 'Sessione',
  User: 'Utente',
};

export const iterableAuditClassNameLabels = Object.keys(auditClassNameLabels)
  .filter((key): key is AuditClassName => !!key)
  .map((key) => ({ label: auditClassNameLabels[key], value: key }));

export const auditTypeLabels: Record<TypeEnum, string> = {
  create: 'Inserimento',
  delete: 'Cancellazione',
  update: 'Aggiornamento',
};

export const iterableAuditTypeLabels = Object.keys(auditTypeLabels)
  .filter((key): key is TypeEnum => !!key)
  .map((key) => ({ label: auditTypeLabels[key], value: key }));


export const getRouteFromClassName = (className: AuditClassName, id: string) => {
  // FIXME: Use `Partial<AuditClassName>`
  const map: Record<any, string> = {
    Base: `/base/manager/${id}`,
    BeneD: `/cards/d/manager/${id}`,
    BeneF: `/cards/f/manager/${id}`,
    BeneMI: `/cards/mi/manager/${id}`,
    BeneOA: `/cards/oa/manager/${id}`,
    BeneS: `/cards/s/manager/${id}`,
    Collezione: `/collections/manager/${id}`,
    DocumentoArc: `/archival-sources/manager/${id}`,
    DocumentoBib: `/bibs-source/manager/${id}`,
    File: `/media/manager/${id}`,
    Persona: `/people/manager/${id}`,
    Role: `/roles/manager/${id}`,
    User: `/users/manager/${id}`,
  };

  return map[className];
};
